// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FirstScreen_wrapper__2bRrk","quizName":"FirstScreen_quizName__150cf"};